
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summer-storage-for-college-students",
      function () {
        return require("private-next-pages/summer-storage-for-college-students/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/summer-storage-for-college-students"])
      });
    }
  